import { PocAssistiveText, PocIcon } from 'commons/components/components-wrapper';
import { DROPDOWN_SEARCH_MIN_CHARACTERS_ALLOWED } from 'core/constants/constants';
import { useTranslation } from 'core/i18n/i18n';
import React from 'react';
import { SearchableDropdownInput } from '../searchable-dropdown.style';
import { keepTextEditingKeysInInput } from '../searchable-dropdown.utils';

type SearchableDropdownCustomSearchInputProps = {
    searchFilter: string;
    placeholder?: string;
    assistiveTextString?: string;
    setSearchFilter: (newValue: string) => void;
    executeSearch?: VoidFunction;
};

export const SearchableDropdownCustomSearchInput: React.FC<SearchableDropdownCustomSearchInputProps> = (props) => {
    const {
        searchFilter,
        setSearchFilter,
        placeholder = 'commons.components.searchable-dropdown.search.placeholder',
        assistiveTextString,
        executeSearch,
    } = props;

    const { t } = useTranslation();

    return (
        <SearchableDropdownInput
            autoFocus
            value={searchFilter}
            placeholder={t(placeholder)}
            onValueChange={(ev) => setSearchFilter(ev.detail)}
            variant="outlined"
            size="small"
            nativeInputProps={{
                onkeydown(ev: KeyboardEvent) {
                    if (ev.key === 'Enter' && searchFilter.length >= DROPDOWN_SEARCH_MIN_CHARACTERS_ALLOWED) {
                        executeSearch?.();
                    }

                    keepTextEditingKeysInInput(ev);
                },
            }}
        >
            <PocIcon slot="prefix" name="search" family="outlined" />
            {assistiveTextString ? <PocAssistiveText>{assistiveTextString}</PocAssistiveText> : undefined}
        </SearchableDropdownInput>
    );
};
